import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import Application from 'talent_search/shared/application';
import { useRediscoveryContext } from 'talent_matching/contexts/rediscovery_user_context';
import CustomFields from 'talent_search/components/custom_fields';
import FieldObject from 'talent_search/components/custom_fields/field_object';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const AdvancedFiltersGroup = () => {
  const { apiClient, currencies } = useRediscoveryContext();
  const { watch, setValue } = useFormContext();
  const [applicationFields, customFields] = watch([
    'application_fields',
    'custom_fields',
  ]);

  const countValidFields = (fields: unknown[]): number =>
    (fields || []).filter(
      (f) =>
        f !== null &&
        f !== undefined &&
        typeof (f as FieldObject).isValid === 'function' &&
        (f as FieldObject).isValid()
    ).length;

  const appliedCount =
    countValidFields(applicationFields ?? []) +
    countValidFields(customFields ?? []);

  const clear = () => {
    setValue('application_fields', [], { shouldDirty: true });
    setValue('custom_fields', [], { shouldDirty: true });
  };

  const buttonLabel = `${t('advanced_filters')}${
    appliedCount ? ` (${appliedCount})` : ''
  }`;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('advanced_filters')}
      width="700px"
    >
      <Stack spacing={3}>
        <Application apiClient={apiClient} currencies={currencies} />
        <CustomFields apiClient={apiClient} currencies={currencies} />
        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear} size="lg">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default AdvancedFiltersGroup;
